module.exports = __webpack_public_path__ + "static/media/IMG_4c.8d3fd72c.jpg";